import { Alert, Button, Checkbox, Col, notification, Row, Space } from "antd";
import { CustomCard } from "../../../shared/components/CustomCard/CustomCard";
import CustomForm from "../../../shared/components/CustomForm";
import { prestationInputs } from "./PrestationResumeForm";
import {
  roles,
  statusPrestationsValues,
  subStatus,
} from "../../../utils/constants";
import { GrClearOption } from "react-icons/gr";
import SignatureCanvas from "react-signature-canvas";
import { MessageInfo } from "../../../shared/components/MessageInfo/MessageInfo";
import { ActionRoleSpecific, userHasLevel } from "../../../engine/AuthRoute";
import React, { useContext, useEffect, useRef, useState } from "react";
import useDeviceDetect from "../../../engine/hooks/useDeviceDetect";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "../../../utils/dayjs";
import { UserContext } from "../../../engine/context/User.context";
import {
  finishPrestation,
  getPrestation,
  setPropertiesPrestation,
  updatePrestation,
} from "../Slices/Prestation.slice";
import {
  confirmFinishPrestation,
  prestationFinish,
  prestationsFinishSuccess,
} from "../../../shared/components/Modals/modals";
import { FaFileSignature } from "react-icons/fa";
import { LuClipboardSignature } from "react-icons/lu";
import { BsFillSendFill } from "react-icons/bs";
import { http } from "../../../engine/api/http";
import routes from "../../../engine/routes";
import moment from "moment";
import { t } from "i18next";
import { usePrestationDisabler } from "../../../engine/hooks/usePrestationDisabler";

export const PrestationSigning = ({ toApproved, formDisabledResume }) => {
  const { user, configuration } = useContext(UserContext);

  const { isMobile } = useDeviceDetect();
  const [signing, setSigning] = useState(false);

  const { id } = useParams();
  const { prestation, loading, loadingAppel } = useSelector(
    state => state.prestation,
  );

  const [disabled] = usePrestationDisabler();

  let canvaRef = useRef(null);

  const [hasSetSignature, setHasSetSignature] = useState(false);
  const [confirmAutorisation, setConfirmAutorisation] = useState(false);
  const [confirmNoSigning, setConfirmNoSigning] = useState(false);
  const [confirmAdmin, setConfrimAdmin] = useState(false);
  const [canSignResponsable, setCanSignResponsable] = useState(false);
  const formRef = useRef(null);
  const [width, setWidth] = useState(0);

  const navigate = useNavigate();

  const { status } = prestation;

  const isFinish = [
    statusPrestationsValues.finish,
    statusPrestationsValues.finish_notsigned,
    statusPrestationsValues.finish_permanance,
  ].includes(prestation.status);

  const isCancel = [statusPrestationsValues.cancel].includes(prestation.status);

  const updateWidth = () => {
    const element = document.querySelector("#layout-content");
    if (element) {
      setWidth(element.offsetWidth - 20);
    }
  };

  const dispatch = useDispatch();

  useEffect(() => {
    if (hasSetSignature && canvaRef.current !== null) {
      updateWidth();
    }
  }, [hasSetSignature, canvaRef.current]);

  useEffect(() => {
    if (
      !hasSetSignature &&
      prestation?.interventionFinal?.signing !== "" &&
      canvaRef.current !== null
    ) {
      setHasSetSignature(true);
    }
  }, [
    prestation?.interventionFinal?.signing,
    canvaRef.current,
    signing,
    hasSetSignature,
  ]);

  const prestationRef = useRef(prestation);

  useEffect(() => {
    prestationRef.current = prestation;
  }, [prestation]);

  const setCanvaImage = (prestationData, widthData) => {
    if (
      canvaRef.current !== null &&
      canvaRef.current.isEmpty() &&
      widthData !== 0
    ) {
      // canvaRef.current.clear();

      canvaRef.current.fromDataURL(
        prestationRef.current.interventionFinal.signing,
        {
          ratio: 1,
          width: widthData,
          height: 200,
        },
      );
    }
  };

  useEffect(() => {
    if (hasSetSignature || isFinish) {
      setCanvaImage(prestation, width);
    }
  }, [width, hasSetSignature]);

  // Use useEffect to attach event listeners for window resizing and initial element width
  useEffect(() => {
    // Initial width set
    updateWidth();

    // Update width when the window is resized
    window.addEventListener("resize", updateWidth);

    // Cleanup
    return () => {
      window.removeEventListener("resize", updateWidth);
    };
  }, []);

  const signingDisabled = () => {
    if (user.role === roles.interprete) {
      return toApproved.length === 0 && !formDisabledResume();
    }

    return true;
  };

  const saveFinishedPrestation = async data => {
    await dispatch(setPropertiesPrestation(data));
    await dispatch(updatePrestation());
  };

  const onFinishPrestation = async data => {
    confirmFinishPrestation({
      onOk: async () => {
        let base64Image = canvaRef.current.toDataURL();

        data.interventionFinal ??= {};

        data.interventionFinal.signing = base64Image;

        if (confirmAutorisation) {
          data.status = statusPrestationsValues.finish;
          data.subStatus = subStatus.signed;
        }

        if (confirmNoSigning) {
          data.status = statusPrestationsValues.finish;
          data.subStatus = subStatus.not_signed;
        }

        if (confirmAdmin) {
          data.status = statusPrestationsValues.finish;
          data.subStatus = subStatus.permanance;
        }

        data.interventionFinal.finishAt = dayjs().format();

        await dispatch(setPropertiesPrestation(data));
        await dispatch(finishPrestation());
        // const syncBill = await http.post(`/bills/upsertOneBillOnePrestation`, {
        //   prestation: prestation._id,
        // });
        await dispatch(getPrestation(prestation._id));

        prestationsFinishSuccess({
          onOk: () => {
            navigate(routes.prestations().list.path);
          },
        });
      },
    });
  };

  const renderButtonsSigning = () => {
    const startDate = dayjs(prestation?.intervention?.startDate);
    const today = dayjs();
    // statusPrestationsValues.draft
    // statusPrestationsValues.waiting

    let canRender = false;

    if (
      status === statusPrestationsValues.waiting ||
      status === statusPrestationsValues.draft ||
      status === statusPrestationsValues.noReply ||
      status === statusPrestationsValues.refused ||
      isFinish
    ) {
      return null;
    }

    if (user.role === roles.admin || user.role === roles.permanance) {
      canRender = true;
    } else if (user.role === roles.interprete) {
      // interprete
      if (status === statusPrestationsValues.planned) {
        if (today.isAfter(startDate, "day") || today.isSame(startDate, "day")) {
          canRender = true;
        }
      }
    } else {
      // other role cannot
      return null;
    }

    const finishAndSave = () => {
      formRef.current.submit();
    };

    const signingDisabled = () => {
      if (user.role === roles.interprete) {
        return toApproved.length === 0 && !formDisabledResume();
      }

      return true;
    };

    const beforeStart = moment(
      prestation.intervention.startDate,
    ).isSameOrBefore(moment(), "minute");

    const butterTerminerDisabled = () => {
      if (!confirmAutorisation && !confirmNoSigning && !confirmAdmin) {
        return true;
      }
      if (
        beforeStart === false &&
        userHasLevel({
          not: {
            [roles.admin]: "r", //
            [roles.permanance]: "r", //
          },
        })
      ) {
        return true;
      }
    };

    return canRender ? (
      <ActionRoleSpecific
        only={[roles.interprete, roles.admin, roles.permanance]}
      >
        {isCancel ? null : (
          <>
            {signing &&
            beforeStart === false &&
            userHasLevel({
              not: {
                [roles.admin]: "r", //
                [roles.permanance]: "r", //
              },
            }) ? (
              <Col span={24}>
                <Alert
                  message={t("prestationSigning.cannotCompletePrestation")}
                  type="error"
                  showIcon
                  closable={true}
                />
              </Col>
            ) : null}

            <Col md={12} xs={24}>
              {signing ? (
                <>
                  <Button
                    onClick={finishAndSave}
                    size={"large"}
                    className={"confirmButton"}
                    type={"primary"}
                    disabled={butterTerminerDisabled()}
                    icon={<BsFillSendFill size={20} />}
                  >
                    {t("prestationSigning.completePrestation")}
                  </Button>
                </>
              ) : (
                <Button
                  disabled={!signingDisabled()}
                  onClick={() => setSigning(true)}
                  size={"large"}
                  className={"confirmButton"}
                  type={"primary"}
                  icon={<LuClipboardSignature size={20} />}
                >
                  {t("prestationSigning.signature")}
                </Button>
              )}
            </Col>
            <Col md={12} xs={24}>
              <Button
                disabled={toApproved.length !== 0}
                onClick={() => {
                  setSigning(false);
                }}
                size={"large"}
                className={"confirmButton"}
              >
                {t("prestationSigning.cancel")}
              </Button>
            </Col>
          </>
        )}
      </ActionRoleSpecific>
    ) : null;
  };

  const renderUpdateButtonAdmin = () => {
    return (
      isFinish && (
        <ActionRoleSpecific only={[roles.admin, roles.permanance]}>
          <Col md={12} xs={24}>
            <Button
              disabled={disabled}
              onClick={async () => {
                formRef.current.submit();
              }}
              loading={loading}
              size={"large"}
              className={"confirmButton"}
              type={"primary"}
            >
              {t("prestationSigning.savePrestation")}
            </Button>
          </Col>
        </ActionRoleSpecific>
      )
    );
  };

  return (
    <>
      {signing || isFinish ? (
        <Col span={24}>
          <CustomCard
            title={t("prestationSigning.verificationAndSignature")}
            openDefault={true}
            loading={loading}
          >
            <CustomForm
              disabled={formDisabledResume() || disabled}
              initialValues={prestation}
              dataSource={prestationInputs(prestation, configuration, user)}
              handleSubmit={data => {
                let isValid = false;
                if (
                  data.beneficiary.reference !== "" &&
                  data.beneficiary.reference !== undefined
                ) {
                  isValid = true;
                }

                if (
                  (data.beneficiary.firstname !== undefined &&
                    data.beneficiary.firstname !== "" &&
                    data.beneficiary.firstname.length > 0) ||
                  (data.beneficiary.lastname !== undefined &&
                    data.beneficiary.lastname !== "" &&
                    data.beneficiary.lastname.length > 0) ||
                  data.beneficiary.birthday !== undefined
                ) {
                  isValid = true;
                }

                if (isValid) {
                  return isFinish
                    ? saveFinishedPrestation(data)
                    : onFinishPrestation(data);
                } else {
                  notification.error({
                    message: t("prestationSigning.enterReferenceOrName"),
                  });
                  formRef.current.setFields([
                    {
                      name: "beneficiary.firstname",
                      errors: [t("prestationSigning.enterReferenceOrName")],
                    },
                    {
                      name: "beneficiary.lastname",
                      errors: [t("prestationSigning.enterReferenceOrName")],
                    },
                    {
                      name: "beneficiary.reference",
                      errors: [t("prestationSigning.enterReferenceOrName")],
                    },
                  ]);
                }
              }}
              labelCol={24}
              refForm={formRef}
              wrapperCol={24}
              onValuesChange={undefined}
            />
            <Space direction={"vertical"}>
              <Space
                className={"non-printable"}
                direction={"horizontal"}
                style={{ opacity: isFinish ? 0.7 : 1 }}
              >
                <label>{t("prestationSigning.interpreterSignature")}</label>
                {status === statusPrestationsValues.planned && (
                  <Button
                    size={"small"}
                    onClick={() => {
                      canvaRef.current.clear();
                      setCanSignResponsable(false);
                      setConfirmAutorisation(false);
                    }}
                    icon={<GrClearOption size={20} />}
                  >
                    {t("prestationSigning.clear")}
                  </Button>
                )}
              </Space>

              <SignatureCanvas
                className={"non-printable"}
                id={"SignatureCanvas"}
                disableDrawing={isFinish}
                ref={ref => {
                  canvaRef.current = ref;
                  if (isFinish && ref !== null) {
                    ref.off();
                    const canvas = ref.getCanvas();
                    // canvas.style.pointerEvents = "none";
                  }
                }}
                onBegin={i => {
                  setCanSignResponsable(true);
                }}
                clearOnResize={false}
                penColor={"black"}
                canvasProps={{
                  width: width - 15,
                  height: 200,
                  className: "sigCanvas non-printable",
                }}
              />
              <label className={"only-printable"}>
                {t("prestationSigning.interpreterSignature")}
              </label>
              <div
                className={"printPDF"}
                style={{ width: "100%", float: "left", clear: "both" }}
              ></div>
            </Space>

            {!isFinish && (
              <>
                <MessageInfo
                  message={t("prestationSigning.avicInterventionPayment")}
                />
                <label>
                  <Checkbox
                    style={{
                      opacity: canSignResponsable ? 1 : 0.4,
                    }}
                    disabled={!canSignResponsable}
                    size={"large"}
                    checked={confirmAutorisation}
                    onChange={e => {
                      setConfirmAutorisation(e.target.checked);
                      setConfrimAdmin(false);
                      setConfirmNoSigning(false);
                    }}
                  />
                  <span
                    style={{
                      padding: 15,
                      opacity: canSignResponsable ? 1 : 0.4
                    }}
                  >
                    {t("prestationSigning.confirmResponsibleSignature")}
                  </span>
                </label>
                <br />
                <br />
                <label>
                  <Checkbox
                    size={"large"}
                    checked={confirmNoSigning}
                    onChange={e => {
                      setConfirmAutorisation(false);
                      setConfrimAdmin(false);
                      setConfirmNoSigning(e.target.checked);
                    }}
                  />
                  <span style={{ padding: 15 }}>
                    {t("prestationSigning.finalizeInterventionManually")}
                  </span>
                </label>
                <ActionRoleSpecific only={[roles.permanance, roles.admin]}>
                  <>
                    <br />
                    <br />
                    <label>
                      <Checkbox
                        name={"admin"}
                        size={"large"}
                        checked={confirmAdmin}
                        onChange={e => {
                          setConfirmAutorisation(false);
                          setConfirmNoSigning(false);
                          setConfrimAdmin(e.target.checked);
                        }}
                      />
                      <span style={{ padding: 15 }}>
                        {t("prestationSigning.adminCompletePrestation")}
                      </span>
                    </label>
                  </>
                </ActionRoleSpecific>
              </>
            )}
          </CustomCard>
        </Col>
      ) : null}

      {renderUpdateButtonAdmin()}
      {renderButtonsSigning()}
    </>
  );
};
